// generated during release, do not modify

/**
 * The current version, as set in package.json.
 * @type {string}
 */
export const VERSION = '5.25.6';
export const PUBLIC_VERSION = '5';
